const HR = {
  associationIncorporated: [
    "udruga",
    "gospodarsko interesno udruženje",
    "udruge više razine"
  ],
  partnershipIncorporated: [
    "komanditno društvo (k.d.)"
  ],
  partnershipUnincorporated: [
    "javno trgovačko društvo (j.t.d.)",
    "ortakluk"
  ]
};
export {
  HR as default
};
